import './SpecialMention.scss';

export default function SpecialMention() {
    return (
        <div className='specialMentionSection'>
            <textarea rows="5" placeholder='Special mentions...'></textarea>
        </div>
    )
}